// Import the functions you need from the SDKs you need
import { hasConsent, isConsentReady, onConsentChange } from "@/utils/cookieConsent"
import { initializeApp } from "firebase/app"
import {
  Auth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  inMemoryPersistence,
  initializeAuth,
  setPersistence,
} from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

// Auth is initialized on the client only — the browser-specific persistence and
// popup resolver are invalid on the server (as in the original code, which only
// touched auth inside client effects).
let auth: Auth | undefined

if (typeof window !== "undefined") {
  // With "preferences" consent (or no Cookiebot in dev) init with IndexedDB so the
  // session is restored on reload; otherwise stay in-memory and upgrade on consent.
  const consentedAtLoad = isConsentReady() && hasConsent("preferences")

  auth = initializeAuth(app, {
    persistence: consentedAtLoad
      ? [indexedDBLocalPersistence, browserLocalPersistence]
      : inMemoryPersistence,
    popupRedirectResolver: browserPopupRedirectResolver,
  })

  if (!consentedAtLoad) {
    onConsentChange(() => {
      if (auth && hasConsent("preferences")) {
        setPersistence(auth, indexedDBLocalPersistence).catch(() => {})
      }
    })
  }
}

export { auth }
